module.exports = __webpack_public_path__ + "img/IMGP8637b.86f7692a.jpg";